export const messages = {
  en: {
    housekeepingResource: {
      queryCondition: 'Query Conditions',
      selectResourceType: 'Please select resource type',
      inputResourceName: 'Please input resource name',
      inputSupplierName: 'Please input supplier name',
      serviceResource: 'Service Resources',
      addResource: 'Add Resource',
      editResource: 'Edit Resource',
      deleteConfirm: 'Confirm Delete',
      deleteResourceTip: 'Are you sure to delete this resource and related fee information?',
      typeName: 'Type Name',
      resourceName: 'Resource Name',
      resourceCode: 'Resource Code',
      costPrice: 'Cost Price',
      salePrice: 'Sale Price',
      stock: 'Stock',
      supplierName: 'Supplier Name',
      description: 'Description',
      fee: 'Fee',
      resourceType: 'Resource Type',
      feeType: 'Fee Type',
      supplier: 'Supplier',
      addSupplier: 'Add Supplier',
      requiredResourceType: 'Resource type is required',
      requiredFeeType: 'Fee type is required',
      requiredResourceName: 'Resource name is required',
      requiredResourceCode: 'Resource code is required',
      requiredCostPrice: 'Cost price is required',
      numberCostPrice: 'Cost price must be a number',
      requiredSalePrice: 'Sale price is required',
      numberSalePrice: 'Sale price must be a number',
      requiredStock: 'Stock is required',
      numberStock: 'Stock must be a number',
      requiredSupplier: 'Supplier is required'
    }
  },
  zh: {
    housekeepingResource: {
      queryCondition: '查询条件',
      selectResourceType: '请选择物品类型',
      inputResourceName: '请输入物品名称',
      inputSupplierName: '请输入供应商名称',
      serviceResource: '服务物品',
      addResource: '添加物品',
      editResource: '修改物品',
      deleteConfirm: '确认删除',
      deleteResourceTip: '确定删除服务物品管理及相关联的费用信息吗？',
      typeName: '类型名称',
      resourceName: '物品名称',
      resourceCode: '物品编码',
      costPrice: '成本价',
      salePrice: '出售价',
      stock: '库存',
      supplierName: '供应商名称',
      description: '描述',
      fee: '费用',
      resourceType: '物品类型',
      feeType: '费用大类',
      supplier: '供应商',
      addSupplier: '新增供应商',
      requiredResourceType: '物品类型不能为空',
      requiredFeeType: '费用大类不能为空',
      requiredResourceName: '物品名称不能为空',
      requiredResourceCode: '物品编码不能为空',
      requiredCostPrice: '成本价不能为空',
      numberCostPrice: '成本价必须是数字',
      requiredSalePrice: '出售价不能为空',
      numberSalePrice: '出售价必须是数字',
      requiredStock: '库存不能为空',
      numberStock: '库存必须是数字',
      requiredSupplier: '供应商不能为空'
    }
  }
}